import { ButtonEvent } from "slotworks/graphics/elements/button-element";
import FlexiButton from "slotworks/graphics/elements/flexi-button";
import Layers from "slotworks/graphics/layers/layers";
import AbstractToggleControl from "slotworks/smart-ui/controls/abstract/abstract-toggle-control";
import { Control } from "slotworks/smart-ui/controls/control";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";

export default class AbstractCustomCountToggleControl extends AbstractToggleControl implements Control {

    protected customOnButton: FlexiButton;
    protected customOffButton: FlexiButton;

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.customOnButton = layer.getFlexiButton(assetName + "_on");
        this.customOffButton = layer.getFlexiButton(assetName + "_off");

        this.setSelected(false);

        this.customOnButton.on(ButtonEvent.CLICK, () => this.customOnHandler());
        this.customOffButton.on(ButtonEvent.CLICK, () => this.customOffHandler());
    }

    protected customOnHandler() {
        this.setSelected(false);
    }

    protected customOffHandler() {
        this.setSelected(true);
    }

    protected setSelected(selected: boolean) {
        this.customOnButton.setVisible(selected);
        this.customOnButton.setEnabled(selected);
        this.customOffButton.setVisible(!selected);
        this.customOffButton.setEnabled(!selected);
    }
}
